







import BreadCrumbData from '@/modules/common/components/breadcrumb/breadcrumbData'
import Component from 'vue-class-component'
import page from '@/modules/common/components/page.vue'
import Vue from 'vue'
import workingActivitiesTable from '@/modules/workingactivity/components/workingActivitiesTable.vue'

@Component({
  components: { page, workingActivitiesTable }
})
export default class WorkingActivitiesSettingPage extends Vue {
  breadCrumbData = new BreadCrumbData([{ textKey: 'settings.label' }, { textKey: 'working-activities.label' }])
}
